// import Vue from "vue";
// import { get } from "lodash";

/**
 * Vuex store module for managing Work Allocation Matrix (WAM) state.
 */

export const WAMStore = {
  namespaced: true,

  state: {
    selectedWAM: null, // selected WAM
    configurationOptionsMap: {},
  },

  getters: {
    getSelectedWAM: (state) => state.selectedWAM,
    // getConfigurationOptionsMap: (state) => state.configurationOptionsMap,
    // /**
    //  * Returns configuration options for a given ID.
    //  * @param {string} id - The field type ID for which to get configuration options.
    //  */
    // getConfigurationTypeOptions: (state) => (id) => {
    //   return get(state.configurationOptionsMap, id, []);
    // },
  },

  mutations: {
    SET_CURRENT_WAM(state, payload = null) {
      state.selectedWAM = payload;
    },
    // SET_CONFIGURATION_TYPE_OPTIONS(state, { id, options }) {
    //   Vue.set(state.configurationOptionsMap, id, options);
    // },
  },

  actions: {},
};